// @flow
import React, { Component } from "react"
import { Helmet } from "react-helmet"
import { Route, Redirect, Switch } from "react-router-dom"
import { ConnectedRouter } from "react-router-redux"
import { ApolloProvider } from "react-apollo"
import { addLocaleData } from "react-intl"
import en from "react-intl/locale-data/en"
import es from "react-intl/locale-data/es"
import { darken } from "polished"
import { ThemeProvider } from "styled-components"
import PublicArea from "./PublicArea"
import Admin from "./Admin"
import Kiosk, { Infographic } from "./Kiosk"
import { PrivateRoute } from "./RoutingHelpers"
import { store, history } from "./config/store.js"
import "./UI/DefaultStyles"
import defaultTheme, { darkenFactor } from "./UI/Theme"
import type { Style } from "./UI/Theme"
import { client } from "./API"
import { Authenticator, KioskAuthenticator } from "./Auth"
import { ConnectedIntlProvider } from "./Intl"
import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GA4_ID);

const theme: Style = {
  ...defaultTheme,
  buttonRadius: "0em",
  accent: "#41A3CD",
  primary: "#5E8F45",
  primaryText: "#fff",
  primaryOutline: "#5E8F45",
  primaryHover: darken(darkenFactor, "#5E8F45"),
  linkText: "#41A3CD",
  backgroundGradientLight: "#12204c",
  backgroundGradientDark: "#132048",
}

addLocaleData([...en, ...es])

class App extends Component<any> {
  render() {
    return (
      <ApolloProvider store={store} client={client}>
        <ConnectedIntlProvider>
          <ConnectedRouter history={history}>
            <ThemeProvider theme={theme}>
              <div>
                <Helmet titleTemplate="CAMM - %s" defaultTitle="CAMM - Kiosk">
                  <meta charSet="utf-8" />
                </Helmet>
                <Switch>
                  <PrivateRoute
                    adminRequired={false}
                    path="/kiosk"
                    component={Kiosk}
                  />
                  <Route path="/infographic" component={Infographic} />
                  <Route path="/go/:kioskId" component={KioskAuthenticator} />
                  <Route path="/t/:token" component={Authenticator} />
                  <Route path="/auth" component={PublicArea} />
                  <PrivateRoute
                    path="/admin"
                    adminRequired={true}
                    component={Admin}
                  />
                  <Redirect to="/admin" push={false} />
                </Switch>
              </div>
            </ThemeProvider>
          </ConnectedRouter>
        </ConnectedIntlProvider>
      </ApolloProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js